import apiClient from './client';

export const liveChatApi = {
  createSession: (data) => apiClient.post('/api/live-chat/session', data),
  getSessions: (params) => apiClient.get('/api/live-chat/session', { params }),
  getSessionById: (id, params) => apiClient.get(`/api/live-chat/session/${id}`, { params }),
  closeSession: (id) => apiClient.put(`/api/live-chat/session/${id}/close`),
  assignAgent: (data) => apiClient.post('/api/live-chat/assign-agent', data),
  unassignAgent: (data) => apiClient.put('/api/live-chat/unassign-agent', data),
  listSessionAgents: (id) => apiClient.get(`/api/live-chat/session/${id}/agents`),
  createMessage: (data) => apiClient.post('/api/live-chat/message', data),
  getMessages: (id, params) => apiClient.get(`/api/live-chat/messages/${id}`, { params }),
  deleteMessage: (id) => apiClient.delete(`/api/live-chat/message/${id}`),
  getActiveAssignments: () => apiClient.get('/api/live-chat/assignments/active'),
};

export default liveChatApi;
